export const Base_Url = "https://technoland.api.wowinfosolutions.com/api";
// export const Base_Url = "http://localhost:5000/api";
// export const Base_Url = 'https://technoland.api.wowinfosolutions.com/api';
export const generatePdf_Url = `https://node-js-multipurpose-api.vercel.app`;
